module.exports = __webpack_public_path__ + "src/assets/img/page8/0d9ac4bda02d6f20c6e7887c0c9d52d2.png";